import { useAuth0 } from '@auth0/auth0-react';
import { useQuery } from '@tanstack/react-query';
import API from 'api/API';
import { QueryKeys } from 'api/models/QueryKeys';
import { useHasSuppliersPermission } from 'hooks/useHasSuppliersPermission';

export const useSuppliers = () => {
  const { isAuthenticated } = useAuth0();
  const { data: hasSuppliersPermission } = useHasSuppliersPermission();

  return useQuery({
    queryKey: [QueryKeys.Suppliers],
    queryFn: async () => API.suppliers.getSuppliers(),
    enabled: isAuthenticated && hasSuppliersPermission,
  });
};
